const Adult_dog = [
  {"kg": 3, "Ounces": 7.03, "Grams": 199},
  {"kg": 4, "Ounces": 8.73, "Grams": 247},
  {"kg": 5, "Ounces": 10.32, "Grams": 293},
  {"kg": 6, "Ounces": 11.83, "Grams": 335},
  {"kg": 7, "Ounces": 13.28, "Grams": 376},
  {"kg": 8, "Ounces": 14.68, "Grams": 416},
  {"kg": 9, "Ounces": 16.03, "Grams": 454},
  {"kg": 10, "Ounces": 17.35, "Grams": 492},
  {"kg": 11, "Ounces": 18.64, "Grams": 528},
  {"kg": 12, "Ounces": 19.89, "Grams": 564},
  {"kg": 13, "Ounces": 21.12, "Grams": 599},
  {"kg": 14, "Ounces": 22.33, "Grams": 633},
  {"kg": 15, "Ounces": 23.52, "Grams": 667},
  {"kg": 16, "Ounces": 24.68, "Grams": 700},
  {"kg": 17, "Ounces": 25.83, "Grams": 732},
  {"kg": 18, "Ounces": 26.96, "Grams": 764},
  {"kg": 19, "Ounces": 28.08, "Grams": 796},
  {"kg": 20, "Ounces": 29.18, "Grams": 827},
  {"kg": 21, "Ounces": 30.27, "Grams": 858},
  {"kg": 22, "Ounces": 31.34, "Grams": 888},
  {"kg": 23, "Ounces": 32.41, "Grams": 919},
  {"kg": 24, "Ounces": 33.46, "Grams": 949},
  {"kg": 25, "Ounces": 34.5, "Grams": 978},
  {"kg": 26, "Ounces": 35.53, "Grams": 1007},
  {"kg": 27, "Ounces": 36.55, "Grams": 1036},
  {"kg": 28, "Ounces": 37.56, "Grams": 1065},
  {"kg": 29, "Ounces": 38.56, "Grams": 1093},
  {"kg": 30, "Ounces": 39.55, "Grams": 1121},
  {"kg": 31, "Ounces": 40.54, "Grams": 1149},
  {"kg": 32, "Ounces": 41.51, "Grams": 1177},
  {"kg": 33, "Ounces": 42.48, "Grams": 1204},
  {"kg": 34, "Ounces": 43.44, "Grams": 1232},
  {"kg": 35, "Ounces": 44.4, "Grams": 1259},
  {"kg": 36, "Ounces": 45.35, "Grams": 1286},
  {"kg": 37, "Ounces": 46.29, "Grams": 1312},
  {"kg": 38, "Ounces": 47.22, "Grams": 1339},
  {"kg": 39, "Ounces": 48.15, "Grams": 1365},
  {"kg": 40, "Ounces": 49.08, "Grams": 1391},
  {"kg": 50, "Ounces": 58.02, "Grams": 1645}
];


const dogGrowth_50 = [
  
  {"kg": 3, "Ounces": 13.43, "Grams": 381},
  {"kg": 4, "Ounces": 16.66, "Grams": 472},
  {"kg": 5, "Ounces": 19.7, "Grams": 558},
  {"kg": 6, "Ounces": 22.58, "Grams": 640},
  {"kg": 7, "Ounces": 25.35, "Grams": 719},
  {"kg": 8, "Ounces": 28.02, "Grams": 794},
  {"kg": 9, "Ounces": 30.61, "Grams": 868},
  {"kg": 10, "Ounces": 33.12, "Grams": 939},
  {"kg": 11, "Ounces": 35.58, "Grams": 1009},
  {"kg": 12, "Ounces": 37.98, "Grams": 1077},
  {"kg": 13, "Ounces": 40.33, "Grams": 1143},
  {"kg": 14, "Ounces": 42.63, "Grams": 1209},
  {"kg": 15, "Ounces": 44.9, "Grams": 1273},
  {"kg": 16, "Ounces": 47.12, "Grams": 1336},
  {"kg": 17, "Ounces": 49.32, "Grams": 1398},
  {"kg": 18, "Ounces": 51.48, "Grams": 1459},
  {"kg": 19, "Ounces": 53.61, "Grams": 1520},
  {"kg": 20, "Ounces": 55.71, "Grams": 1579},
  {"kg": 21, "Ounces": 57.78, "Grams": 1638},
  {"kg": 22, "Ounces": 59, "Grams": 1673},
  {"kg": 23, "Ounces": 61.87, "Grams": 1754},
  {"kg": 24, "Ounces": 63.87, "Grams": 1811},
  {"kg": 25, "Ounces": 65.86, "Grams": 1867},
  {"kg": 26, "Ounces": 67.82, "Grams": 1923},
  {"kg": 27, "Ounces": 69.77, "Grams": 1978},
  {"kg": 28, "Ounces": 71.7, "Grams": 2033},
  {"kg": 29, "Ounces": 73.61, "Grams": 2087},
  {"kg": 30, "Ounces": 75.51, "Grams": 2141},
  {"kg": 31, "Ounces": 77.39, "Grams": 2194},
  {"kg": 32, "Ounces": 79.25, "Grams": 2247},
  {"kg": 33, "Ounces": 81.1, "Grams": 2299},
  {"kg": 34, "Ounces": 82.94, "Grams": 2351},
  {"kg": 35, "Ounces": 84.76, "Grams": 2403},
  {"kg": 36, "Ounces": 86.57, "Grams": 2454},
  {"kg": 37, "Ounces": 88.37, "Grams": 2505},
  {"kg": 38, "Ounces": 90.15, "Grams": 2556},
  {"kg": 39, "Ounces": 91.93, "Grams": 2606},
  {"kg": 40, "Ounces": 93.69, "Grams": 2656},
  {"kg": 50, "Ounces": 110.76, "Grams": 3140}
  
];

const dogGrowth_50_80 = [

    {"kg": 3, "Ounces": 11.19, "Grams": 317},
    {"kg": 4, "Ounces": 13.88, "Grams": 393},
    {"kg": 5, "Ounces": 16.41, "Grams": 465},
    {"kg": 6, "Ounces": 18.82, "Grams": 534},
    {"kg": 7, "Ounces": 21.12, "Grams": 599},
    {"kg": 8, "Ounces": 23.35, "Grams": 662},
    {"kg": 9, "Ounces": 25.51, "Grams": 723},
    {"kg": 10, "Ounces": 27.6, "Grams": 782},
    {"kg": 11, "Ounces": 29.65, "Grams": 841},
    {"kg": 12, "Ounces": 31.65, "Grams": 897},
    {"kg": 13, "Ounces": 33.61, "Grams": 953},
    {"kg": 14, "Ounces": 35.53, "Grams": 1007},
    {"kg": 15, "Ounces": 37.41, "Grams": 1061},
    {"kg": 16, "Ounces": 39.27, "Grams": 1113},
    {"kg": 17, "Ounces": 41.1, "Grams": 1165},
    {"kg": 18, "Ounces": 42.9, "Grams": 1216},
    {"kg": 19, "Ounces": 44.67, "Grams": 1266},
    {"kg": 20, "Ounces": 46.42, "Grams": 1316},
    {"kg": 21, "Ounces": 48.15, "Grams": 1365},
    {"kg": 22, "Ounces": 49.86, "Grams": 1414},
    {"kg": 23, "Ounces": 51.55, "Grams": 1461},
    {"kg": 24, "Ounces": 53.23, "Grams": 1509},
    {"kg": 25, "Ounces": 54.88, "Grams": 1556},
    {"kg": 26, "Ounces": 56.52, "Grams": 1602},
    {"kg": 27, "Ounces": 58.14, "Grams": 1648},
    {"kg": 28, "Ounces": 59.75, "Grams": 1694},
    {"kg": 29, "Ounces": 61.34, "Grams": 1739},
    {"kg": 30, "Ounces": 62.92, "Grams": 1784},
    {"kg": 31, "Ounces": 64.49, "Grams": 1828},
    {"kg": 32, "Ounces": 66.04, "Grams": 1872},
    {"kg": 33, "Ounces": 67.59, "Grams": 1916},
    {"kg": 34, "Ounces": 69.12, "Grams": 1960},
    {"kg": 35, "Ounces": 70.63, "Grams": 2002},
    {"kg": 36, "Ounces": 72.14, "Grams": 2045},
    {"kg": 37, "Ounces": 73.64, "Grams": 2088},
    {"kg": 38, "Ounces": 75.13, "Grams": 2130},
    {"kg": 39, "Ounces": 76.61, "Grams": 2172},
    {"kg": 40, "Ounces": 78.08, "Grams": 2214},
    {"kg": 50, "Ounces": 92.3, "Grams": 2617}

 ];


const dogGrowthabove_80 = [
  
  {"kg": 3, "Ounces": 8.95, "Grams": 254},
  {"kg": 4, "Ounces": 11.11, "Grams": 315},
  {"kg": 5, "Ounces": 13.13, "Grams": 372},
  {"kg": 6, "Ounces": 15.05, "Grams": 427},
  {"kg": 7, "Ounces": 16.9, "Grams": 479},
  {"kg": 8, "Ounces": 18.68, "Grams": 530},
  {"kg": 9, "Ounces": 20.41, "Grams": 579},
  {"kg": 10, "Ounces": 22.08, "Grams": 626},
  {"kg": 11, "Ounces": 23.72, "Grams": 672},
  {"kg": 12, "Ounces": 25.32, "Grams": 718},
  {"kg": 13, "Ounces": 26.89, "Grams": 762},
  {"kg": 14, "Ounces": 28.42, "Grams": 806},
  {"kg": 15, "Ounces": 29.93, "Grams": 849},
  {"kg": 16, "Ounces": 31.42, "Grams": 891},
  {"kg": 17, "Ounces": 32.88, "Grams": 932},
  {"kg": 18, "Ounces": 34.32, "Grams": 973},
  {"kg": 19, "Ounces": 35.74, "Grams": 1013},
  {"kg": 20, "Ounces": 37.14, "Grams": 1053},
  {"kg": 21, "Ounces": 38.52, "Grams": 1092},
  {"kg": 22, "Ounces": 39.89, "Grams": 1131},
  {"kg": 23, "Ounces": 41.24, "Grams": 1169},
  {"kg": 24, "Ounces": 42.58, "Grams": 1207},
  {"kg": 25, "Ounces": 43.9, "Grams": 1245},
  {"kg": 26, "Ounces": 45.22, "Grams": 1282},
  {"kg": 27, "Ounces": 46.51, "Grams": 1319},
  {"kg": 28, "Ounces": 47.8, "Grams": 1355},
  {"kg": 29, "Ounces": 49.07, "Grams": 1391},
  {"kg": 30, "Ounces": 50.34, "Grams": 1427},
  {"kg": 31, "Ounces": 51.59, "Grams": 1463},
  {"kg": 32, "Ounces": 52.83, "Grams": 1498},
  {"kg": 33, "Ounces": 54.07, "Grams": 1533},
  {"kg": 34, "Ounces": 55.29, "Grams": 1567},
  {"kg": 35, "Ounces": 56.51, "Grams": 1602},
  {"kg": 36, "Ounces": 57.71, "Grams": 1636},
  {"kg": 37, "Ounces": 58.91, "Grams": 1670},
  {"kg": 38, "Ounces": 60.1, "Grams": 1704},
  {"kg": 39, "Ounces": 61.29, "Grams": 1738},
  {"kg": 40, "Ounces": 62.46, "Grams": 1771},
  {"kg": 50, "Ounces": 73.84, "Grams": 2093}

  ];

function get_feedinfo(dog_weight,dog_is,fully_grown,feed_planarr){
const kgValueToFind = dog_weight;
const dog_stag = dog_is;
const dogfully_grown = fully_grown;

const dogfeed_planarr = feed_planarr;
//console.log(kgValueToFind);

if(dog_stag =="A puppy"){
  if(dogfully_grown =="Under 50% fully grown"){
      //alert("50%");
      var elementWithKg = dogGrowth_50.find(element => element.kg === kgValueToFind);
  }
  else if(dogfully_grown =="50-80% fully grown"){
      //alert("50-80%");
      var elementWithKg = dogGrowth_50_80.find(element => element.kg === kgValueToFind);
  }
  else if(dogfully_grown =="Over 80% fully grown"){
      //alert("80%");
      var elementWithKg = dogGrowthabove_80.find(element => element.kg === kgValueToFind);
  }
}
else{
      //alert("Adult_dog");
      var elementWithKg = Adult_dog.find(element => element.kg === kgValueToFind);
}

console.log(elementWithKg);
  
if (elementWithKg) {
    //console.log("Element with kg value", elementWithKg);
    const kg = elementWithKg.kg;
    const ounces = elementWithKg.Ounces;
    const grams = elementWithKg.Grams;

    // result append
    $(".full_meal_res,.txtfull_meal_res").text(grams+"g");
    const halfmeal = Math.ceil(grams/2);
    $(".half_meal_res,.txthalf_meal_res").text(halfmeal+"g");

    console.log("kg:"+kg);
    console.log("Ounces:"+ounces);
    console.log("grams:"+grams);

} else {
    console.log("Element with kg value not found.");
}

}

$("#step-2").click(function(){

      if($('#breedItems li').length >= 1){
      $( "#breedItems li" ).each(function( index ) {
              breedsmix =$( this ).text(); 
      });
        console.log(breedsmix);
        var breeds_input = $("#breeds").val();
        $("#breeds").val(breeds_input+"|"+breedsmix); 
      } 
    var queryString = $('#feeding_plan_step_form').serialize();
    //alert(queryString);
    var fieldValuePairs = $('#feeding_plan_step_form').serializeArray();
    var valuesByName = {};
    for (var i = 0; i < fieldValuePairs.length; i++) {
    var field = fieldValuePairs[i];
    valuesByName[field.name] = field.value;
        
     }
       var dogs_is = valuesByName['dogs_is'];
       var dog_weight = parseInt(valuesByName['dog_weight']); 
       var fully_grown = valuesByName['fully_grown']; 
       var dog_breeds = valuesByName['breeds']; 
       //console.log(dog_breeds);

        // Select the recipe bases on seleced calculator  
        if($("#product_feedplan").val()!=""){
        var current_feedcalculator = $("#product_feedplan").val();
        var feedarr = current_feedcalculator;
        var feed_planarr = JSON.parse(feedarr);
        }
       get_feedinfo(dog_weight,dogs_is,fully_grown,feed_planarr);
       $("#Step2").click();
  });

$( document ).ready(function() {
  
    var have_form = $('#build_feeding_plan');
    if ( have_form.length){
          console.log("show--");
        //you can now reuse  $myDiv here, without having to select it again.
        const links = document.getElementsByTagName("a");
        for (let i = 0; i < links.length; i++) {
            if (links[i].getAttribute("href") === "#build_feeding_plan") {
                links[i].classList.add("feed_formscroll");
            }
        }
        
    }
    else{
       console.log("hide--");
       const links = document.getElementsByTagName("a");
        for (let i = 0; i < links.length; i++) {
            // Check if the href attribute equals "#build_feeding_plan"
            if (links[i].getAttribute("href") === "#build_feeding_plan") {
                // Hide the <a> tag
                links[i].style.display = "none";
            }
        }
    }

$(".feed_formscroll").click(function() {
    $('html,body').animate({
        scrollTop: $("#build_feeding_plan").offset().top},
        'slow');
});
  
});